import { isNetworkUser } from 'src/components/User/utils';

const isCaseManagerAndAbove = (user, groupId) => {
  return !isNetworkUser(user, groupId);
};

export default isCaseManagerAndAbove;
